const hashRoutes = {
    registrationDialog: '#signup',
    loginDialog: '#sign-in',
    forgotPasswordDialog: '#forgot-password',
    checkConfirmSignupDialog: '#check-confirm-signup',
    successConfirmSignupDialog: '#success-confirm-signup',
    failedConfirmSignupDialog: '#failed-confirm-signup',
    wrongReferralLinkCode: '#wrong-referral-link-code',
    depositDialog: '#deposit',
    withdrawDialog: '#withdraw',
    fortuneWheel: '#fortune-wheel',
    chat: '#chat',
};

module.exports.hashRoutes = hashRoutes;

module.exports.dialogsHashRoutes = [
    hashRoutes.registrationDialog,
    hashRoutes.loginDialog,
    hashRoutes.forgotPasswordDialog,
    hashRoutes.checkConfirmSignupDialog,
    hashRoutes.successConfirmSignupDialog,
    hashRoutes.failedConfirmSignupDialog,
    hashRoutes.wrongReferralLinkCode,
    hashRoutes.depositDialog,
    hashRoutes.withdrawDialog,
    hashRoutes.fortuneWheel,
    hashRoutes.chat,
];